$(function() {
    // $(".Hero-autoScroll").click(function() {
    //     var section = $(this).closest("section");
    //     var next = section.next("section");

    //     if (next) {
    //         var offsetTop = next.offset().top - $("header").outerHeight();

    //         $("html, body").animate({
    //             scrollTop: offsetTop
    //         });
    //     }
    // });

    // $(".Hero-feed--slider").flickity({
    //     contain: true,
    //     imagesLoaded: true,
    //     pageDots: false
    // });

    $(".HeroSlider-container").flickity({
        cellSelector: ".HeroSlider-slide",
        autoPlay: 4500,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        groupCells: 1,
        wrapAround: true,
        setGallerySize: false,
        friction: 0.7,
        cellAlign: "center"
    });
});



// WEBPACK FOOTER //
// ../modules/Hero/assets/scripts/main.js